import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ExpandableBar from 'widgets/Bar/ExpandableBar';

const AccordionElement = ({ children, title, onElementClick, index, expanded }) => (
  <div className="gn-accordionElement">
    <ExpandableBar
      onElementClick={(e) => (onElementClick && onElementClick(index, e))}
      expanded={expanded}
    >
      {title}
    </ExpandableBar>
    <div
      aria-hidden={!expanded}
      className={classNames('gn-accordionElement__content', { 'gn-accordionElement__content--expanded': expanded })}
    >
      <div className="gn-accordionElement__wrapper">
        {children}
      </div>
    </div>
  </div>
);

AccordionElement.propTypes = {
  expanded: PropTypes.bool,
  children: PropTypes.node,
  title: PropTypes.node,
  onElementClick: PropTypes.func,
  index: PropTypes.number,
};

AccordionElement.defaultProps = {
  expanded: false,
};

export default AccordionElement;
